import { render } from "./AdaptiveTextBlockNew.vue?vue&type=template&id=1afee7ee&scoped=true"
import script from "./AdaptiveTextBlockNew.vue?vue&type=script&lang=js"
export * from "./AdaptiveTextBlockNew.vue?vue&type=script&lang=js"

import "./AdaptiveTextBlockNew.vue?vue&type=style&index=0&id=1afee7ee&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afee7ee"]])

export default __exports__